// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"60dd5633","296":"a8f5a184","508":"8bc753ee","552":"7f417b6b","726":"1a8dbb13","877":"488cf97d","946":"2b688346"}[chunkId] + ".chunk.js";
};